module.exports = "<section class=\"basic_inpector_param_view\">\n\t<span class=\"param_label\"><%= label %></span>\n</section>"